import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import React from 'react';

type Props = {
  value: string,
  title?: string
};

export const CopyToClipboard = ({ value, title }: Props) => {
  const performCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(value);
    }
  };

  return (
    <Button className="clipboard-copy" variant="secondary" size="sm" title={title} onClick={performCopy}>
      <FontAwesomeIcon icon={faClipboard} />
    </Button>
  );
};

export default CopyToClipboard;
